import { FormDataApis } from '../../ApisForm.model';
import { GenderOption } from './PersonalData.model';

export const validateTwoSurnames = (value: string, formValues: FormDataApis, isInfant: boolean): boolean => {
	const splitSurname = value.trim().split(' ');
	const watchNationality =
		isInfant && formValues.infant
			? formValues.infant.personalData.nationality.value
			: formValues.personalData.nationality.value;
	const isNationalityES = watchNationality === 'ES';
	const errorTwoSurnames = splitSurname.length < 2 || splitSurname.some((surnam) => surnam.length < 2);

	return isNationalityES && errorTwoSurnames;
};
export const getMinDate = (typePassenger: string): Date | undefined => {
	let nowDate: Date | undefined = new Date();
	switch (typePassenger) {
		case 'CHILD':
			nowDate.setFullYear(nowDate.getFullYear() - 4);
			break;
		case 'INFANT':
			nowDate.setFullYear(nowDate.getFullYear() - 2);
			break;

		default:
			nowDate = undefined;
			break;
	}

	return nowDate;
};
export const genderOptions: GenderOption[] = [
	{ value: 'MALE', label: 'GENDER_MALE' },
	{ value: 'FEMALE', label: 'GENDER_FEMALE' }
];
